import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function Countdown({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  const {
    h,
    m,
    s
  } = useCountdown();
  const box = tone === 'light' ? 'bg-white/10 text-white ring-1 ring-white/20' : 'bg-petrol text-white ring-1 ring-petrol/30';
  const label = tone === 'light' ? 'text-white/70' : 'text-white/70';
  const units: Array<[string, string]> = [[h, 'H'], [m, 'Min'], [s, 'Sec']];
  return <div className="flex items-center justify-center gap-2" role="timer" aria-live="off" data-id="element-50" data-mp="3h0pgfj9ctrwn">
      {units.map(([value, unit]) => <div key={unit} className={`min-w-[62px] rounded-lg px-3 py-2 text-center ${box}`} data-id="element-51" data-mp="324rmm7mwkznl">
          <span className="block font-display text-2xl font-extrabold tabular-nums sm:text-3xl" data-id="element-52" data-mp="373ugqx1chlgs">
            {value}
          </span>
          <span className={`block font-display text-[10px] font-bold uppercase tracking-widest ${label}`} data-id="element-53" data-mp="10d4prpgbyaj7">
            {unit}
          </span>
        </div>)}
    </div>;
}